import { useInstalledWallets } from '@/hooks/useInstalledWallets';
import { WalletType, WalletTypeExtended } from '@/context/types';
import { Wallets } from '@/constants/Wallets';

import ConnectWalletItem from './connect-wallet-item';

const getIsWalletInstalled = (walletType: WalletType, installedWallets: WalletTypeExtended[]): boolean => {
  return installedWallets.some((installedWallet) => installedWallet === (walletType as unknown as WalletTypeExtended));
};

interface WalletListProps {
  isButtonBlocked: boolean;
  handleConnect: (walletType: WalletType | WalletTypeExtended) => Promise<void>;
}

// const iconMap = {
//   xverse: <Icons.xverse className="size-20" />,
//   unisat: <Icons.unisat className="size-20" />,
//   leather: <Icons.leather className="size-20" />,
// };

const WalletList: React.FC<WalletListProps> = ({ isButtonBlocked, handleConnect }: WalletListProps) => {
  const installedWallets = useInstalledWallets();

  return (
    <div className='flex flex-col gap-8 lg:gap-[60px] w-full px-6 lg:px-12 py-6 lg:py-8'>
      <p className='text-center text-xl leading-6 tracking-02em text-text-secondary'>Select your preffered wallet to open a vault.</p>
      <div className='flex flex-col gap-4 lg:gap-8 text-text-primary'>
        {Object.values(WalletType).map((walletType, index) => (
          <ConnectWalletItem
            {...Wallets[walletType]}
            isInstalled={getIsWalletInstalled(walletType, installedWallets)}
            isButtonBlocked={isButtonBlocked}
            walletType={walletType}
            connect={handleConnect}
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export default WalletList;
